import BannerGeneral from "../../components/BannerGeneral";
import Block2ColumnsText from "../../components/Block2ColumnsText";
import BlockBackgroundImage from "../../components/BlockBackgroundImage";
import BlockLeftImage from "../../components/BlockLeftImage";
import BlockRightImage from "../../components/BlockRightImage";
import SocialShare from "../../components/SocialShare";

function TecEstrategica() {
  return (
    <>
      <div className="padding ">
        <article class="nota-utpl" lang="es">
          <div className=" padding2 layout6 ">
            <header>
              <center>
                <h2>
                  ¿Cómo afecta el consumo de tabaco
                  <b> a la genética humana?</b>
                </h2>

                <p className="fontsize14">
                  Un análisis científico <b>desde Loja</b> para comprender sus
                  riesgos en la salud
                </p>
                <p className="iconsize20">🔬🧬</p>
              </center>
            </header>
            <p className="fontsize14">
              Estudios recientes demuestran que las sustancias generadas por la
              combustión del tabaco{" "}
              <b>
                no solo afectan los pulmones, sino que también provocan daños a
                nivel genético,{" "}
              </b>{" "}
              incrementando el riesgo de desarrollar enfermedades como el
              cáncer.
            </p>
            <div className="bluebg padding2">
              {" "}
              <BlockRightImage
                src="https://noticias.utpl.edu.ec/sites/default/files/tabaco_genes_dos.png"
                content={
                  <>
                    <p>
                      La Universidad Técnica Particular de Loja (UTPL),
                      comprometida con la investigación y la generación de
                      conocimiento, impulsa proyectos científicos que analizan
                      el impacto del tabaco en la genética humana, con el
                      objetivo de aportar evidencia que permita fortalecer la
                      prevención y la toma de decisiones en salud pública.
                    </p>
                    <p>
                      La investigación se enfoca en comprender cómo las
                      variantes genéticas influyen en la respuesta del organismo
                      frente a sustancias tóxicas derivadas del tabaco.
                      <b>
                        {" "}
                        Este enfoque permite identificar factores de riesgo
                        individuales y colectivos, contribuyendo a una
                        comprensión más profunda de las enfermedades asociadas
                        al tabaquismo.
                      </b>
                    </p>
                  </>
                }
              ></BlockRightImage>
            </div>
            <h3 className="margin">
              Evidencia científica que alerta sobre <b>riesgos en la salud</b>
            </h3>
            <p>
              Las investigaciones realizadas en la ciudad de Loja revelan datos
              relevantes sobre el impacto del tabaco en la población. El estudio
              analiza a 321 personas entre 20 y 59 años, incluyendo tanto
              fumadores como no fumadores, mediante técnicas avanzadas de
              biología molecular y genotoxicología.
            </p>
            <p>
              Los resultados evidencian que aproximadamente el{" "}
              <b>
                10% de la población presenta alteraciones genéticas relacionadas
                con enzimas encargadas de procesar sustancias tóxicas.
              </b>{" "}
              Esta condición incrementa la vulnerabilidad al daño celular
              causado por el tabaco. Además, se ha identificado una mayor
              presencia de alteraciones en las células de los fumadores, como
              fragmentación del ADN y procesos de muerte celular, lo que
              confirma el efecto directo del tabaco sobre la integridad
              genética.
            </p>
          </div>

          <div className="padding2 layout6">
            <h2>
              {" "}
              Investigación aplicada para la <b> salud pública</b>
            </h2>

            <p>
              El estudio se centra en el análisis de enzimas como la glutatión
              S-transferasa, fundamentales para la eliminación de compuestos
              tóxicos en el organismo. Cuando estas enzimas presentan
              variaciones genéticas, disminuye la capacidad de defensa del
              cuerpo, aumentando el riesgo de enfermedades.
            </p>
          </div>
          <div className="layout6 lightbluebg padding icon300">
            <center>
              <h3>
                {" "}
                <b>
                  {" "}
                  Voces expertas: <br></br>
                </b>{" "}
              </h3>{" "}
            </center>
            <BlockLeftImage
              src="https://sica.utpl.edu.ec/media/uploads/docentes/fotos/web/low/1104087018_low.jpg"
              content={
                <>
                  <p>
                    Durante la combustión del cigarrillo se generan sustancias
                    altamente tóxicas y carcinogénicas que pueden afectar
                    diversos tejidos del cuerpo. Nuestro objetivo es comprender
                    cómo estas sustancias, en interacción con las variantes
                    genéticas, impactan la estabilidad del ADN.
                  </p>
                  <p>
                    <b>Gabriela Cevallos Solorzano</b>
                  </p>
                  <p>Docente investigadora de la UTPL</p>
                  <a
                    href="https://investigacion.utpl.edu.ec/gcevallos"
                    className="link-with-arrow"
                  >
                    {" "}
                    Ver perfil
                  </a>
                </>
              }
            ></BlockLeftImage>
          </div>
          <div className="layout6 margin">
            <h3>
              Ciencia para <b>transformar la prevención </b>
            </h3>
            <p>
              Este tipo de investigaciones permite avanzar hacia un enfoque más
              integral de la salud pública, donde la prevención se basa en
              evidencia científica y en la comprensión de factores biológicos,
              sociales y conductuales.
            </p>
          </div>

          <div className="lightbluebg padding layout6">
            <center>
              <p className="fontsize14">
                {" "}
                <b>
                  {" "}
                  La maestría en Análisis Biológico y Diagnóstico de Laboratorio
                  forma profesionales con competencias avanzadas en análisis
                  clínicos y diagnóstico,{" "}
                </b>
                fundamentales para la detección y seguimiento oportuno de
                diversas enfermedades.{" "}
              </p>
              <p>
                El programa promueve una visión integral del proceso
                salud–enfermedad desde el enfoque de la atención primaria de
                salud, sustentado en principios éticos y científicos. A través
                de una formación especializada, los profesionales fortalecen su
                capacidad para contribuir al bienestar de la persona, la familia
                y la comunidad mediante un diagnóstico preciso y oportuno.
              </p>
            </center>
          </div>
        </article>
        <br></br>
        <center>
          <h2> ¿Interesado en nuestra oferta? </h2>
          <a
            className="button"
            target="_blank"
            href="https://utpl.edu.ec/maestria-analisis-biologico"
          >
            {" "}
            Matricúlate ahora
          </a>

          <br></br>
          <h4>Comparte esta noticia</h4>

          <SocialShare
            title="¿Cómo afecta el consumo de tabaco a la genética humana?"
            url="https://utpl.edu.ec/efectos-consumo-tabaco"
            imageUrl="https://noticias.utpl.edu.ec/sites/default/files/tabaco_genes_dos.png"
          >
            {" "}
          </SocialShare>
        </center>
      </div>

      <BannerGeneral></BannerGeneral>

      <script>
        var metaImg = document.createElement('meta');
        metaImg.setAttribute('property', 'og:image'); metaImg.content =
        'https://noticias.utpl.edu.ec/sites/default/files/nota-especializaciones.png';
        document.getElementsByTagName('head')[0].appendChild(metaImg); var
        metaTitle = document.createElement('meta');
        metaTitle.setAttribute('property', 'og:title'); metaTitle.content = '
        ¿Por qué los médicos deben especializarse en Imagenología y
        Anestesiología?';
        document.getElementsByTagName('head')[0].appendChild(metaTitle);
      </script>
    </>
  );
}

export default TecEstrategica;
